import { IUpgradeAccountToEnterpriseStatePlgExternal3 } from '.';
import { BlockedByFeature } from '../../../featureToggles/features/utils';
import { RootState } from '../../rootReducer';
import { IUpgradeAccountToEnterpriseState } from './interfaces';

const getUpgradeAccountToEnterpriseState = (state: Pick<RootState, 'accounts'>): IUpgradeAccountToEnterpriseState | undefined => {
  const upgradeAccountToEnterpriseState: IUpgradeAccountToEnterpriseStatePlgExternal3 = state.accounts.upgrade;
  if (upgradeAccountToEnterpriseState === BlockedByFeature) {
    return;
  }
  return upgradeAccountToEnterpriseState;
};

const isSaving = (state: Pick<RootState, 'accounts'>): boolean => getUpgradeAccountToEnterpriseState(state)?.saving ?? false;

export const selectors = {
  isSaving
};